import React from "react";
import { Icons, Box, Button, Stack, Typography } from "@curves/ui-base";
import ProductInfo from "@icoach/pos/components/ProductInfo";
import { formatCurrencyFn, isFunction } from "@util/utils";

const CartItem = ({ item, sequenceNumber, isLast = false, showDiscount = false, onClickCartItem, onRemove }) => {
	const { id, quantity, currentPrice, discountPrice = 0 } = item;

	// 計算小計（原價）
	const itemTotal = currentPrice * quantity - discountPrice;

	// 點擊處理函式
	const handleClick = () => {
		isFunction(onClickCartItem) && onClickCartItem(item);
	};

	return (
		<Box className={`pos-cart-item ${isLast ? "pos-cart-item-last" : ""}`}>
			<Stack direction="row" spacing={2} alignItems="center">
				<Stack className="pos-cart-item-box" direction="row" spacing={2} alignItems="center" onClick={handleClick}>
					<Box className="pos-cart-sequence-badge">{sequenceNumber}</Box>

					<ProductInfo product={item} showEditIcon />

					<Box className="pos-cart-item-qty">{quantity}</Box>

					{showDiscount && (
						<Box className="pos-cart-item-discount">
							<Typography className="discount-text mb-0">{discountPrice ? `-${formatCurrencyFn(discountPrice, { symbol: "$" })}` : ""}</Typography>
						</Box>
					)}

					<Box className="pos-cart-item-total">{formatCurrencyFn(itemTotal, { symbol: "$" })}</Box>
				</Stack>
				<Button color="error" size="small" onClick={() => onRemove?.(id)} className="pos-cart-remove-button">
					<Icons.Close />
				</Button>
			</Stack>
		</Box>
	);
};

export default CartItem;
